export const PROJECT_MEETINGS_CONFIG = {
    name            : 'Meetings',
    icon            : 'i5-meeting',
    // iconLight       : 'i5-meeting-light',
    image           : 'meetings',
    iconSvg         : 'isvg-view-meetings',
    url             : 'meetings',
    stringId        : 'meetings',
    description     : 'List of project-related meetings.',
    menuName        : 'Meetings',
    inheritance     : false,
    isSingleton     : true,
}
